module.exports = __webpack_public_path__ + "static/media/12UNCTAD1.8e9cdea1.jpg";